import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { InfoDialogComponent } from '../components/info-dialog/info-dialog.component';
import { AgreeOn } from '../models/agree-on';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
    providedIn: 'root'
})

export class ApiErrorWarningInterceptor implements HttpInterceptor {
    
    constructor(public dialog: MatDialog){}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(map(event => {
            if (event instanceof HttpResponse && event.body) {
                if (event.body.hasOwnProperty('warnings') && event.body.warnings && event.body.warnings.length > 0)
                {
                    var agreeDto = new AgreeOn();
                    agreeDto.title =""
                    agreeDto.text =  event.body.warnings
                    const dialogRef = this.dialog.open(InfoDialogComponent, {
                      width: '400px',
                      data: agreeDto
                    });
                }
                if (event.body.hasOwnProperty('errors') && event.body.errors && event.body.errors.length > 0)
                {
                    var agreeDto = new AgreeOn();
                    agreeDto.title =""
                    agreeDto.text =  event.body.errors
                    const dialogRef = this.dialog.open(InfoDialogComponent, {
                      width: '400px',
                      data: agreeDto
                    });     
                }
            }         
            return event;
        }));
    }
}
  